export default __webpack_public_path__ + "static/media/0085.2f83918b.jpg";